import * as Yup from 'yup'
import 'yup-phone-lite'
import './validators/ssn'

export default Yup
